import { render, staticRenderFns } from "./CheckMyClinicDoctorsDialog.vue?vue&type=template&id=ff867580&scoped=true"
import script from "./CheckMyClinicDoctorsDialog.vue?vue&type=script&lang=js"
export * from "./CheckMyClinicDoctorsDialog.vue?vue&type=script&lang=js"
import style0 from "./CheckMyClinicDoctorsDialog.vue?vue&type=style&index=0&id=ff867580&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff867580",
  null
  
)

export default component.exports